import { SwitchElement } from 'react-hook-form-mui';

export default SwitchElement;
